import List from "@/components/list";

const Table = args => {

  const tableConfig = [
    {
      label: "作业名称",
      prop: "workName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "完成率",
      prop: "completeRate",
      minWidth: "150",
      showOverflowTooltip: true
    }
  ];
  return (
    <List
      {...args}
      talbeCols={tableConfig}
    />
  );
};

export default Table;
